var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashNoItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.698 6.33C12.6176 5.44992 13.8629 4.95511 15.1616 4.95511C16.4603 4.95511 17.7056 5.44992 18.6252 6.33C19.544 7.21235 20.0608 8.40895 20.0608 9.6569C20.0608 10.9041 19.544 12.1008 18.6252 12.983L15.7257 15.7365L8.79851 9.08427L11.698 6.33Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37428 12.3863L8.24156 9.63275L15.1687 16.285L12.3014 19.0778C11.064 20.2661 9.26015 20.7299 7.56974 20.2955C5.87924 19.8604 4.55928 18.592 4.10617 16.9686C3.65306 15.346 4.13606 13.6137 5.37426 12.4255L5.37428 12.3863Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashNoItems);
export default __webpack_public_path__ + "static/media/dash-no-items.a6af2fdbdfb20d9990661ab04203f241.svg";
export { ForwardRef as ReactComponent };